// @flow
import { call, put, select, takeEvery } from 'redux-saga/effects';
import type { RoamingActionType } from './actions';
import { setRoamingCountry } from './actions';
import { CommonActions } from '@react-navigation/native';
import { selectedRoamingPackageSelector } from '../../TopUps/Bundle/selectors';
import { tripica } from '../../../api';
import HandleErrorService from '../../../lib/handleError';
import { setRoamingBundles } from '../../TopUps/Bundle/actions';
import { setLoading } from '../../LoadingStatus/actions';
import { addTopUpToSelection, initTopUp, topUpUsages } from '../../TopUps/actions';
import Navigation from '../../../lib/navigation';
import WizzeeLog from '../../../lib/wizzeeLog';

export function* setRoamingPackageSaga(action: RoamingActionType): Generator<*, *, *> {
  if (action.type !== 'SET_ROAMING_PACKAGE') return;

  yield put(setRoamingCountry(action.payload.country));
  yield call(
    Navigation.dispatch,
    CommonActions.navigate({
      name: 'roamingOffer',
      params: { comesFromDashboard: action.payload.comesFromDashboard },
    })
  );
}

export function* buyRoamingPackage(action: RoamingActionType): Generator<*, *, *> {
  if (action.type !== 'BUY_ROAMING_PACKAGE') return;

  const roamingPackage = yield select(selectedRoamingPackageSelector);
  yield put(initTopUp());
  yield put(addTopUpToSelection(roamingPackage));
  yield put(topUpUsages());
}

export function* fetchRoamingBundlesSaga(): Generator<*, *, *> {
  try {
    yield put(setLoading('roamingOffer', true));
    const roamingBundles = yield call([tripica, 'getRoamingBundle']);
    yield put(setRoamingBundles(roamingBundles));
  } catch (e) {
    WizzeeLog.warn('[saga] fetchRoamingBundlesSaga', e);
    HandleErrorService.showToastError(e);
  } finally {
    yield put(setLoading('roamingOffer', false));
  }
}

export default function*(): Generator<*, *, *> {
  yield* [takeEvery('SET_ROAMING_PACKAGE', setRoamingPackageSaga), takeEvery('BUY_ROAMING_PACKAGE', buyRoamingPackage)];
  yield* [takeEvery('FETCH_ROAMING_BUNDLES', fetchRoamingBundlesSaga)];
}
